import { createSlice } from "@reduxjs/toolkit";

export const metaSlice = createSlice({
    name: "meta",
    initialState: {
        subscriptionDialogOpen: false,
        pendingDowngradeDialogOpen: false,
        surveyDirty: false,
    },
    reducers: {
        setSubscriptionDialogOpen: (state, action) => {
            state.subscriptionDialogOpen = action.payload;
        },
        setPendingDowngradeDialogOpen: (state, action) => {
            state.pendingDowngradeDialogOpen = action.payload;
        },
        setSurveyDirty: (state, action) => {
            state.surveyDirty = action.payload;
        },
    },
    extraReducers() {},
});

export const { setSubscriptionDialogOpen, setPendingDowngradeDialogOpen, setSurveyDirty } = metaSlice.actions;

export const metaSelector = (state) => state[metaSlice.name];

export default metaSlice.reducer;
